
<div>
    <ng-container *ngTemplateOutlet="formEntitySection;context:{IELIST: ieEntityVisible, FORMGROUP : ieEntity.InterfaceElementGroup}">
    </ng-container>
</div>
<div *ngIf="ieEntityVisible.length == 0">
  <button class="btn btn-warning btn-sm" *ngIf="uxControllerService.RTKeyAllowDynaEdit" (click)="uxControllerService.openDynaEditor(ieEntity,dynaEditorTemplate)">
    <i id="button_DynaEdit"></i>
  </button>
</div>
<ng-template #formEntitySection let-interfaceElementList="IELIST" let-group="FORMGROUP">
  <div class="form-group row">
    <div [class]="ieEntity.Attributes.AssignedColumnWidth + ' form-group'" [formGroup]="group">
    <ng-container *ngFor="let ie of interfaceElementList;let i = index">
    
      <div class="form-group row" *ngIf="!(ie.CustomizeOptions != null  && ie.CustomizeOptions.DisplayType == 'barecode')">

        <label class="col-sm-3 col-form-label-sm" [attr.for]="ie.InterfaceElementID" >
          <ng-container  *ngIf="(ie.DisplayProperties.IsDisplayOnUI == true)">  {{ie.DisplayProperties.DisplayName}}</ng-container>
        </label>
        <div class="col-sm-1">
          <app-cosy-checkbox *ngIf="(ie.Attributes.Nullable && ie.Values.length > 0 && RTKeyShowNullable)" [nullValue]="true" [ie]="ie" [formgroup]="group" [RTKeyShowNullable]=RTKeyShowNullable></app-cosy-checkbox>
         
          <div *ngIf="(ie.CustomizeOptions  != null  && ie.CustomizeOptions.DisplayType == 'document' && ie.CustomizeOptions.Mode != 'withoutUpload')" class="icon-display-position">
            <button class="btn btn-light" (click)="showNdownloadPDF(ie,'show', false )">
              <i id="button_Pdf"></i>
            </button>
            <button class="btn btn-light" (click)="showNdownloadPDF(ie,'download', false)">
              <i id="button_FileDownload"></i>
            </button>
          </div>
        </div>
        <div class="col-sm-7">
          <div *ngIf="(ie.CustomizeOptions != null  && ie.CustomizeOptions.DisplayType == 'document' && ie.CustomizeOptions.Mode == 'withoutUpload')" class="icon-display-position">
            <button class="btn btn-light" (click)="showNdownloadPDF(ie,'show', false )">
              <i id="button_Pdf"></i>
            </button>
            <button class="btn btn-light" (click)="showNdownloadPDF(ie,'download', false)">
              <i id="button_FileDownload"></i>
            </button>
          </div>
         
          <app-cosy-inputtext *ngIf="(ie.TypeDID == IE_TYPES.InputText && !(ie.CustomizeOptions != null && ie.CustomizeOptions.Mode == 'withoutUpload'))
                                  || (ie.TypeDID == IE_TYPES.InputNumber) || (ie.TypeDID == IE_TYPES.InputDate) " [ie]="ie" [formgroup]="group"></app-cosy-inputtext>
          <app-cosy-picklist *ngIf="(ie.TypeDID == IE_TYPES.InputPicklist)" [ie]="ie" [formgroup]="group" [formType]="ieEntity.TypeDID" [RTKeyShowNullable]=RTKeyShowNullable></app-cosy-picklist>
          <app-cosy-checkbox *ngIf="(ie.TypeDID == IE_TYPES.InputBoolean)" [ie]="ie" [formgroup]="group" [RTKeyShowNullable]=RTKeyShowNullable></app-cosy-checkbox>
          <app-cosy-trigger *ngIf="(ie.TypeDID == IE_TYPES.Trigger)" [formgroup]="group" [ie]="ie"></app-cosy-trigger>
          
          <app-cosy-validatormessage *ngIf="ie.Messages?.length > 0" [ie]="ie" [formgroup]="group"></app-cosy-validatormessage>
        </div>
        <div class="col-sm-1">
          <button class="btn btn-warning btn-sm" *ngIf="(i == 0) && (uxControllerService.RTKeyAllowDynaEdit)" (click)="uxControllerService.openDynaEditor(ieEntity,dynaEditorTemplate)">
            <i id="button_DynaEdit"></i>
        </button>
        </div>
         
        <div style="display:none" [id]="'doc-'+ ie.InterfaceElementID" class="col-sm-11 top-buffer" *ngIf="(ie.TypeDID == IE_TYPES.InputText) && (ie.CosyDataTypeID == IE_COSY_TYPES.InputTextCosyDataTypeID)">
          <ngx-extended-pdf-viewer 
          [base64Src]="pdfBase64" 
          [showOpenFileButton]=false
          [showBookmarkButton]=false
          [showSecondaryToolbarButton]=true
          [showSpreadButton]=false
          [showPropertiesButton]=false
          [showSidebarButton]=false
          [showScrollingButton]=false
          [(zoom)]=uxControllerService.zoom  
          [(rotation)]=uxControllerService.rotation 
          [(page)]=uxControllerService.page 
          [delayFirstView]="1000"
          [useBrowserLocale]="true" height="90vh"></ngx-extended-pdf-viewer>
       </div>
      </div>
    </ng-container>
  </div>
  <div [class]="'col-md-' + ieEntityBaseCSSStyle + ' form-group'" [formGroup]="group">
    <ng-container *ngFor="let ie of ieEntityDocument;let i = index">
        <div style="display:block" [id]="ie.InterfaceElementID + '_init'" class="col-sm-12 top-buffer" *ngIf="(ie.TypeDID == IE_TYPES.InputText) && (ie.CosyDataTypeID == IE_COSY_TYPES.InputTextCosyDataTypeID)">
          <ngx-extended-pdf-viewer   
            [logLevel]=0  
            [base64Src]="pdfBase64"  
            [textLayer]=false  
            [(zoom)]=uxControllerService.zoom  
            [(rotation)]=uxControllerService.rotation  
            [(page)]=uxControllerService.page 
            useBrowserLocale="true"
            height="90vh">
          </ngx-extended-pdf-viewer>
          <!--<ngx-extended-pdf-viewer 
           [base64Src]="pdfBase64" 
           [showOpenFileButton]=false
           [showBookmarkButton]=false
           [showSecondaryToolbarButton]=true
           [showSpreadButton]=false
           [showPropertiesButton]=false
           [showSidebarButton]=false
           [showScrollingButton]=false
           [(zoom)]=uxControllerService.zoom  
           [(rotation)]=uxControllerService.rotation 
           [(page)]=uxControllerService.page 
           delayFirstView=0
           [textLayer]=false
           [useBrowserLocale]="true" height="90vh"></ngx-extended-pdf-viewer>-->
        </div>
    </ng-container>
  </div>
  </div>
</ng-template>
